import React, { Fragment, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

//Helpers
import { OrderData } from 'Core/data/Helpers';

//Components
import { Modal, Button, IconButton, SearchInput, Tooltip } from '@gpstrackit/gtc-react-controls';
import { NotificationContainer } from "Components/Notifications";
import { NotificationManager } from 'Components/Notifications';
import { Grid } from '@mui/material';

//Views
import CreateEditDriverTask from '../createEditDriverTask'

//Actions
import {
    maintenanceMMTSearchMaintenanceDriverTasks,
    maintenanceMMTDeleteMaintenanceDriverTask,
    reset,
} from './redux/slice';
import { openModalCreateDriverTasks } from 'Redux/actions';

//Styles
import './styles.scss';
const ManageTask = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const {
        open,
        driverTasks,
        loading,
        deleteResponse,
        error,
    } = useSelector(state => state.maintenanceManageTasksRedux);
    const { createDriverTaskResponse, updateDriverTaskResponse } = useSelector(state => state.maintenanceCreateDriverTasksRedux);
    const openCreateDriverTasks = useSelector(state => state.maintenanceCreateDriverTasksRedux.open);

    //Local States
    const [search, setSearch] = useState('');
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [currentDriverTaskToDelete, setCurrentDriverTaskToDelete] = useState(null);
    const [sortedDriverTasks, setSortedDriverTasks] = useState([]);

    useEffect(() => {
        if (open) {
            dispatch(maintenanceMMTSearchMaintenanceDriverTasks({ name: '' }))
        }
    }, [open]);

    useEffect(() => {
        if (driverTasks && driverTasks.length) {
            setSortedDriverTasks(OrderData(driverTasks, 'name'));
        }
    }, [driverTasks]);

    useEffect(() => {
        if (deleteResponse) {
            handleCloseDelete();
            NotificationManager.success(
                messages['driversTasksTab_deleteConfirmationSuccessfully'],
                messages['success'],
                3000,
                null,
                null,
                'success',
            );
            setSearch("")
            dispatch(maintenanceMMTSearchMaintenanceDriverTasks({ name: '' }))
            dispatch(reset({ deleteResponse: null }))
        }
        if (error) {
            NotificationManager.error(
                error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
            dispatch(reset({ error: null }))
        }
        if (createDriverTaskResponse?.id || updateDriverTaskResponse?.id) {
            dispatch(maintenanceMMTSearchMaintenanceDriverTasks({ name: search || '' }))
        }
    }, [deleteResponse, error, createDriverTaskResponse, updateDriverTaskResponse])


    /*  useEffect(() => {
         if (openUpdateDriverTaskModal && createDriverTask && createDriverTask.id) {
             NotificationManager.success(
                 messages['success'],
                 messages['driversTasksTab_createdNewDriverTask'],
                 3000,
                 null,
                 null,
                 'success'
             );
             dispatch( maintenanceMMTSearchMaintenanceDriverTasks({ name: search }))
             //getDriverTasks(search);
         }
     }, [createDriverTask]); */

    /* useEffect(() => {
        if (openUpdateDriverTaskModal && updateDriverTask && updateDriverTask.id) {
            NotificationManager.success(
                messages['driversTasksTab_updatedSuccessfully'],
                messages['success'],
                3000,
                null,
                null,
                'success',
            );
            dispatch( maintenanceMMTSearchMaintenanceDriverTasks({ name: search }))
            //getDriverTasks(search);
        }
    }, [updateDriverTask]) */

    const openDriverTask = (driverTask) => {
        dispatch(openModalCreateDriverTasks({ open: true, taskId: driverTask?.id }))
    };

    const getTxtTooltipList = (attachments) => {
        /*  return attachments.map((attachment, key) => {
             return <p key={key}>{attachment.name}</p>;
         }); */
    };

    const handleCloseDelete = () => {
        setOpenModalDelete(false);
        setCurrentDriverTaskToDelete(null);
    };

    const handleDelete = () => {
        if (currentDriverTaskToDelete?.id) {
            dispatch(maintenanceMMTDeleteMaintenanceDriverTask({ id: currentDriverTaskToDelete?.id }))
        }
        //handleCloseDelete();
    };

    const handleClose = () => {
        setSearch('');
        setCurrentDriverTaskToDelete(null);
        dispatch(reset());
    }

    const renderItems = () => {
        return (
            <Fragment>
                {sortedDriverTasks && sortedDriverTasks.map((item, key) => {
                    return (
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className="manage-tasks-items"
                            key={key}
                        >
                            <Tooltip title={messages['edit']}>
                                <Grid
                                    item
                                    className="manage-tasks-items-container "
                                    onClick={() => openDriverTask(item)}
                                >
                                    <div>
                                        <span className="manage-tasks-items-title">{item.name}</span>
                                    </div>
                                    <div>
                                        <p className="manage-tasks-items-description">
                                            {messages['driversTasksTab_repeatEvery']} {item.frequency} {item.timeUnit || 'Days'}
                                        </p>
                                    </div>
                                </Grid>

                            </Tooltip>

                            <Grid item>
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Grid item>
                                        <IconButton
                                            type="icon"
                                            icon="comment"
                                            tooltip={item.description}
                                            onClick={() => { }}
                                        />
                                    </Grid>
                                    {item?.attachments?.length > 0 && (
                                        <Grid item>
                                            <IconButton
                                                icon="attach_file"
                                                tooltip={getTxtTooltipList(item.attachments)}
                                                onClick={() => { }}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item>
                                        <IconButton
                                            icon="delete"
                                            tooltip={messages['delete']}
                                            onClick={() => {
                                                setOpenModalDelete(true);
                                                setCurrentDriverTaskToDelete(item);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
            </Fragment>
        );
    };

    const onSearchText = useCallback((newSearchText) => {
        setSearch(newSearchText);
        if (window.typingTime) clearTimeout(window.typingTime)
        window.typingTime = setTimeout(() => {
            dispatch(maintenanceMMTSearchMaintenanceDriverTasks({ name: newSearchText }))
        }, 500);
    });

    return (
        <Fragment>
            <Modal
                title={messages['driversTasksTab_manageTask']}
                open={open}
                handleClose={handleClose}
                position="right"
                size="small"
                loading={loading}
                footer={(
                    <div>
                        <Button
                            onClick={handleClose}
                            variant="secondary"
                            style={{ marginRight: "5px" }}
                        >
                            {messages['cancel']}
                        </Button>
                        <Button
                            onClick={() => dispatch(openModalCreateDriverTasks({ open: true }))}
                            variant="primary"
                        >
                            {messages['driversTasksTab_newTask']}
                        </Button>
                    </div>
                )}
            >
                <div style={{ padding: '10px 25px' }}>
                    <SearchInput
                        searchText={search}
                        onSearchText={onSearchText}
                        placeholder={messages['search']}
                    />
                    {renderItems()}
                </div>
                <NotificationContainer />
            </Modal>
            <Modal
                size="small"
                open={openModalDelete}
                handleClose={handleCloseDelete}
                title={`${messages['driversTasksTab_delete']} "${currentDriverTaskToDelete && currentDriverTaskToDelete?.name}"`}
                loading={loading}
                footer={(
                    <div>
                        <Button
                            variant="secondary"
                            onClick={handleCloseDelete}
                            style={{ marginRight: "5px" }}
                        >
                            {messages['cancel']}
                        </Button>
                        <Button
                            onClick={(e) => handleDelete()}
                            variant="warning"
                            disabled={loading}
                        >
                            {messages['driversTasksTab_delete']}
                        </Button>
                    </div>
                )}
            >
                <div style={{ padding: '10px 25px' }}>
                    <p style={{ overflowWrap: 'anywhere' }}>
                        {messages['driversTasksTab_deleteConfirmation']}
                        {`"${currentDriverTaskToDelete && currentDriverTaskToDelete?.name}" ?`}
                    </p>
                </div>
                <NotificationContainer />
            </Modal>
            {openCreateDriverTasks && <CreateEditDriverTask />}
        </Fragment>
    );
};




export default ManageTask;
